import { Component, Input } from '@angular/core';

@Component({
  selector: 'lgv-hours-minutes-table-item',
  template: '{{ value | hourFormatterLarge }}',
  standalone: false,
})
export class HoursMinutesTableItemComponent {
  @Input() value: any;
}
